import { Link, useNavigate } from "react-router-dom";
import { Home, Building2, Globe2, Briefcase, Trash2, Wrench, ArrowRight } from "lucide-react";

function MilitairesLink() {
  const navigate = useNavigate();
  const go = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/demenagement-militaire");
  };
  return (
    <span
      role="link"
      tabIndex={0}
      data-testid="service-mutation-militaires-link"
      onClick={go}
      onKeyDown={(e) => e.key === "Enter" && go(e)}
      className="text-[#237cb5] font-semibold underline underline-offset-2 hover:text-[#FF7A00] transition-colors cursor-pointer"
    >
      militaires
    </span>
  );
}

const SERVICES = [
  {
    icon: Home,
    title: "Déménagement particulier",
    text: "Studio, appartement ou maison : un service soigné et adapté à chaque logement.",
    to: "/demenagement-particulier",
  },
  {
    icon: Building2,
    title: "Transfert d'entreprise",
    text: "Bureaux, mobilier, archives, matériel pro : un transfert organisé sans perte d'activité.",
    to: "/entreprise",
  },
  {
    icon: Globe2,
    title: "Déménagement international",
    text: "Projets longue distance et international, organisés selon votre destination.",
    to: "/international",
  },
  {
    icon: Briefcase,
    title: "Mutation professionnelle",
    text: (
      <>
        Solutions dédiées aux salariés, <MilitairesLink /> et professionnels en mutation.
      </>
    ),
    to: "/mutation-professionnelle",
  },
  {
    icon: Trash2,
    title: "Débarras et vide-maison",
    text: "Vider un logement, une cave ou un local avant ou après votre déménagement.",
    to: "/debarras-vide-maison",
  },
  {
    icon: Wrench,
    title: "Montage et démontage",
    text: "Démontage et remontage de vos meubles (lits, armoires, dressings, mobilier IKEA).",
    to: "/montage-demontage-meubles",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-10 sm:py-14 bg-[#f7fafc] border-y border-[#e6edf3]">
      <div className="bd-container">
        <div className="max-w-3xl">
          <span className="bd-eyebrow">Nos prestations</span>
          <h2 data-testid="services-h2" className="bd-h2 mt-5 text-[26px] sm:text-[30px] lg:text-[36px]">
            Nos <span style={{ color: "#237cb5" }}>services de déménagement</span>
          </h2>
          <p className="mt-6 text-[#3a4a5a] text-base leading-relaxed">
            Nous vous accompagnons pour tous vos projets de déménagement en Île-de-France,
            que vous soyez particulier ou professionnel.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-stretch">
          {/* Photo on the left */}
          <div className="lg:col-span-5">
            <div
              data-testid="services-photo"
              className="relative w-full h-full min-h-[420px] rounded-3xl overflow-hidden shadow-[0_30px_60px_-30px_rgba(35,124,181,0.4)]"
            >
              <img
                src="/images/emballage-meuble-film-big-dem.webp"
                alt="Déménageur Big Déménagement protégeant une armoire avec film noir avant transport"
                className="absolute inset-0 h-full w-full object-cover"
                loading="lazy"
                decoding="async"
                width="1000"
                height="1200"
              />
            </div>
          </div>

          {/* Services cards — 2 columns × 3 rows */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            {SERVICES.map(({ icon: Icon, title, text, to }, i) => (
              <Link
                key={title}
                to={to}
                data-testid={`service-card-${i}`}
                className="group relative bd-card p-5 sm:p-6 flex flex-col h-full"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#eaf3fb] text-[#237cb5]"
                    aria-hidden="true"
                  >
                    <Icon className="h-4.5 w-4.5" />
                  </span>
                  <h3 className="font-bold text-[15px] sm:text-base text-[#0f1d2b] leading-snug">{title}</h3>
                </div>
                <p className="mt-3 text-[13px] leading-relaxed text-[#5b6b7a] flex-1">{text}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#237cb5]">
                  En savoir plus
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
